const initBlockPortalTags = () => {
    const blockWrappers = document.querySelectorAll('.block-tags__inner');
    if (blockWrappers) {
        blockWrappers.forEach((block) => {
            const tagElem = block.querySelector('.block-tags__tag-item');
            if (!tagElem) {
                return;
            }
            const tagElemHeight = tagElem.clientHeight;
            let gap = 0;
            if (block && block instanceof HTMLElement) {
                const theCSSprop = window.getComputedStyle(block, null).getPropertyValue('gap');
                gap = theCSSprop ? parseInt(theCSSprop) : 0;
                block.style.height = tagElemHeight + 'px';
                block.style.overflow = 'hidden';
                const tagElements = block.querySelectorAll('.block-tags__tag-item');
                let countTagsIsNotVisible = 0;
                const blockRect = block.getBoundingClientRect();
                if (tagElements) {
                    tagElements.forEach((tag) => {
                        const tagRect = tag.getBoundingClientRect();
                        if (!(tagRect.left >= blockRect.left && tagRect.right <= blockRect.right &&
                            tagRect.top >= blockRect.top &&
                            tagRect.bottom <= blockRect.bottom)) {
                            countTagsIsNotVisible++;
                        }
                    });
                    if (block) {
                        const blockNAElement = block === null || block === void 0 ? void 0 : block.nextElementSibling;
                        if (blockNAElement && blockNAElement instanceof HTMLElement) {
                            if (countTagsIsNotVisible === 0) {
                                blockNAElement.style.display = 'none';
                            }
                            else {
                                blockNAElement.innerHTML = `+ ще ${countTagsIsNotVisible}`;
                                blockNAElement.addEventListener('click', (event) => {
                                    if (event.target instanceof HTMLElement) {
                                        const elem = event.target;
                                        if (block.classList.contains('openned')) {
                                            block.classList.remove('openned');
                                            block.style.height = tagElemHeight + gap + 'px';
                                            block.style.overflow = 'hidden';
                                            event.target.innerHTML = `+ ще ${countTagsIsNotVisible}`;
                                        }
                                        else {
                                            event.target.innerHTML = `- ${countTagsIsNotVisible}`;
                                            block.classList.add('openned');
                                            block.style.height = '100%';
                                            block.style.overflow = 'none';
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            }
        });
    }
};
export default initBlockPortalTags;
